/* global theme, pinCampaignModalStrings */

import {
  prizeQuantityFields,
  pinForm,
  customLineItemOnePropertiesArray,
  customLineItemTwoPropertiesArray,
  customPrizeContainers,
  pinCountMessaging,
  selectors,
  klaviyo,
  modal,
  pinManagement,
  provinceOfResidenceField,
} from './global.js';

import { utils } from './utils.js';

import {
  validateAll,
  showWinOrLose,
  addPinFields,
  removePinField,
  getSelectPrizes,
} from './validation.js';

import PinQtySelector from './classes/pin-quantity-selector.js';

// Shared instance of AddressValidation
import addressValidation from './classes/address-validation.js';

import populatePinForm from './functions/populate-pin-form.js';

// NOTES:
// "Province of Residence" is the contest field. "Province" is the Household Limit field. They are independent of each other and serve different purposes.

window.theme = window.theme || {};

(function ($) {
  /*==========================================================================
    CACHE DOM
  ============================================================================*/
  var prizeSelectSubmit = document.getElementById('prize-select-submit');

  /*==========================================================================
    INITIALIZERS
  ============================================================================*/
  function init() {
    if (document.querySelector('#page-content-campaign-expired')) {
      return;
    }

    bindEvents();

    // init new quantity selectors
    $('#page-content-prize-selection')
      .find('.js-qty__wrapper')
      .each(function (index, el) {
        var selector = new PinQtySelector($(el), {
          namespace: '.pin-campaign',
        });
      });

    populatePinForm();

    // TODO: listen for changes to check if they've exceeded the allowed qty
  }

  function bindEvents() {
    $('body').on('click', selectors.pinEntryAdd, function () {
      addPinFields(this);
    });

    $('body').on('click', selectors.pinEntryRemove, function () {
      removePinField(this);
    });

    // BEGIN update html element attributes for later use in ErrorValidation
    const emailField = document.querySelector('#email');
    const emailConfirmationField = document.querySelector(
      '#email-confirmation'
    );
    emailField.addEventListener('keyup', (e) => {
      // ErrorValidation will use this pattern to check if the emails match or not
      emailConfirmationField.pattern = e.target.value;
    });

    function setMaxDate() {
      const dobField = document.querySelector('#date-of-birth');
      const d = new Date();
      d.setFullYear(d.getFullYear() - utils.getLegalAge());

      const dateXYearsAgo = `${d.getFullYear()}-${(
        '0' +
        (d.getMonth() + 1)
      ).slice(-2)}-${('0' + d.getDate()).slice(-2)}`;

      dobField.max = dateXYearsAgo;
    }

    if (utils.isContest()) {
      setMaxDate();

      // ErrorValidation will use this max date to check if the birthday is valid
      provinceOfResidenceField.addEventListener('change', () => {
        setMaxDate();
      });
    }
    // END update html element attributes for later use in ErrorValidation

    // submit pin form
    pinForm.addEventListener('submit', function (e) {
      e.preventDefault();
      validateAll();
    });

    // submit prize selection
    prizeSelectSubmit.addEventListener('click', function () {
      var _this = this;

      // block submit button
      _this.disabled = true;

      // if there are still wining PINs in the array
      if (!!pinManagement.winningPinsArray.length) {
        // loop the custom properties inputs and build the custom line item properties arrays
        var cartAttributes = [];

        for (var i = 0; i < customPrizeContainers.length; i++) {
          var customPrizeContainer = customPrizeContainers[i],
            prizeNumber = customPrizeContainer.getAttribute(
              'data-custom-prize-number'
            ),
            inputBoxOne = document.getElementById(
              'CustomInputLineOne-' + prizeNumber
            ),
            inputBoxTwo = document.getElementById(
              'CustomInputLineTwo-' + prizeNumber
            ),
            customLineItemPropertyOne = inputBoxOne.value,
            customLineItemPropertyTwo = inputBoxTwo.value,
            customProductId = 'productCustomized-' + i,
            cartAttributeData =
              customProductId +
              ': Name, Line One: ' +
              customLineItemPropertyOne +
              ', Name, Line Two: ' +
              customLineItemPropertyTwo;

          customLineItemOnePropertiesArray.push(customLineItemPropertyOne);
          customLineItemTwoPropertiesArray.push(customLineItemPropertyTwo);
          cartAttributes.push(cartAttributeData);
        }

        // add selected products to cart
        theme.cart
          .addItemFromForm({
            items: getSelectPrizes(
              customLineItemOnePropertiesArray,
              customLineItemTwoPropertiesArray
            ),
          })
          .then(function () {
            $('body').trigger('added.ajaxProduct');

            klaviyo.trackEvent('Prize(s) added to cart');

            // after adding items, if we have custom cart attributes, post those
            if (
              typeof cartAttributes !== 'undefined' &&
              cartAttributes.length > 0
            ) {
              var cartAttributesString = cartAttributes.toString();
              var randomId = utils.makeId(6);
              var cartAttributesFinal =
                'attributes[Customizations-' +
                randomId +
                ']=' +
                '"' +
                cartAttributesString +
                '"';

              // https://community.shopify.com/c/Shopify-APIs-SDKs/jQuery-post-on-cart-update-js-with-throw-a-status-on-fail-but/td-p/468244
              $.post('/cart/update.js', cartAttributesFinal, null, 'json')
                .done(function () {})
                .fail(function (data) {
                  console.log('error');
                });
            }

            // hide the "X of Y PINs were winneres" messaging that they have
            // already seen
            for (var i = 0; i < pinCountMessaging.length; i++) {
              pinCountMessaging[i].style.display = 'none';
            }

            // reset the winning PINs array
            pinManagement.winningPinsArray = [];

            // after user selection submit, go to "winner page"
            showWinOrLose(true);
          })
          .catch(function () {
            // if there are still PINs left, this is the casue of the error.
            if (pinManagement.winningPinsArray.length) {
              // error modal
              modal.updateMessage(
                unescape(pinCampaignModalStrings.strings.pickYourPrizes)
              );
            } else {
              // error modal
              modal.updateMessage(
                unescape(pinCampaignModalStrings.strings.generalError)
              );
            }
            modal.open();

            // unblock submit button
            _this.disabled = false;
          });
      }
    });

    // change prize quantity fields
    for (var i = 0; i < prizeQuantityFields.length; i++) {
      var prizeQuantityField = prizeQuantityFields[i],
        previousValue;

      prizeQuantityField.addEventListener('focus', function () {
        previousValue = parseInt(this.value);
      });
    }

    // NOTE: There is an event listener in the CartDrawer module (theme.js) that
    // allows for the removal of prize items from the cart. It used to live here,
    // but it needs to function from every page
  }

  $(document).ready(function () {
    init();
  });
})(theme.jQuery);
